import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Typography,
  Chip,
  Link,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { postreadCountAnnouncementsSlice } from "../../../redux/actions/postreadCountAnnouncementsSlice";

export default function SupplierAnnouncementCard({
  id,
  title,
  description,
  date,
  postedBy,
  isNew,
  attachmentUrl,
  attachmentName,
  attachmentType,
  announcementType,
}) {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [read, setRead] = useState(isNew);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    setExpanded((prev) => !prev);

    if (!read && !loading) {
      try {
        setLoading(true);

        const userEmail = localStorage.getItem("userEmail");

        const response = await dispatch(
          postreadCountAnnouncementsSlice({
            dynamicEndpoint: `/api/announcements/${id}/read`,
          })
        );

        if (response?.meta?.requestStatus === "fulfilled") {
          setRead(true); // hide badge
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: "#fff",
        borderRadius: "12px",
        border: "1px solid #e5e7eb",
        p: 2,
        pl: 3.5,
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
    >
      {/* LEFT BLUE BAR */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 6,
          bottom: 6,
          width: "5px",
          background: "#3b82f6",
          borderTopRightRadius: "6px",
          borderBottomRightRadius: "6px",
        }}
      />

      {/* HEADER */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        gap={2}
      >
        <Box>
          <Typography fontWeight={600} fontSize={15}>
            {title}
          </Typography>

          <Typography fontSize={11} color="#6b7280" mt={0.5}>
            Posted by: {postedBy}
          </Typography>
        </Box>

        <Typography
          fontSize={12}
          color="#6b7280"
          whiteSpace="nowrap"
        >
          {new Date(date).toLocaleDateString()}
        </Typography>
      </Box>

      {/* TYPE */}
      {announcementType && (
        <Chip
          label={announcementType?.replaceAll("_", " ")}
          size="small"
          sx={{
            mt: 1,
            fontSize: 11,
            height: 22,
          }}
        />
      )}

      {/* DESCRIPTION */}
      {expanded && (
        <>
          <Typography
            fontSize={13}
            color="#4b5563"
            mt={1.5}
            lineHeight={1.6}
          >
            {description}
          </Typography>

          {/* ATTACHMENT */}
          {attachmentUrl && (
            <Box
              mt={1.5}
              display="flex"
              alignItems="center"
              gap={1}
            >
              <Link
                href={attachmentUrl}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{
                  fontSize: 13,
                  wordBreak: "break-word",
                }}
              >
                {attachmentName}
              </Link>

              {attachmentType && (
                <Typography
                  fontSize={11}
                  color="#9ca3af"
                >
                  ({attachmentType})
                </Typography>
              )}
            </Box>
          )}
        </>
      )}

      {/* VIEW MORE / LESS */}
      <Typography
        onClick={handleToggle}
        sx={{
          mt: 1.5,
          fontSize: 12,
          color: "#2563eb",
          cursor: "pointer",
          fontWeight: 600,
          width: "fit-content",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {expanded ? "View Less" : "View More"}
      </Typography>

      {/* NEW BADGE */}
      {read === false && (
        <Box
          sx={{
            position: "absolute",
            top: -6,
            right: -6,
            background: "#ef4444",
            color: "#fff",
            fontSize: "10px",
            px: 1,
            py: 0.3,
            borderRadius: "999px",
            fontWeight: 700,
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          }}
        >
          NEW
        </Box>
      )}
    </Box>
  );
}